import { Link } from 'react-router-dom';
import { featuredArticles, articles } from '@/mocks/sports';

export default function ArticlesSection() {
  const displayArticles = featuredArticles.length >= 3 ? featuredArticles.slice(0, 3) : articles.slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-4">
              最新资讯
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              体育资讯精选
            </h2>
          </div>
          <Link
            to="/category/football"
            className="text-sm font-medium text-primary-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {displayArticles.map((article, idx) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer flex flex-col"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-background-50/90 backdrop-blur-sm text-primary-700 rounded-full">
                    {article.category}
                  </span>
                </div>
                {idx === 0 && (
                  <div className="absolute top-3 right-3">
                    <span className="px-2 py-0.5 text-xs font-bold bg-accent-500 text-foreground-950 rounded">精选</span>
                  </div>
                )}
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-3">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-4 leading-relaxed flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between pt-3 border-t border-background-200">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}